export default __webpack_public_path__ + "static/1-3-design-system-4e9a84fedd68c4242fa4354045ed311e.gif";